import request from './request'

//根据职位生成岗位要求
export function generateJDByPosition(data) {
  return request({
    url: '/api/jd/generateJDByPosition',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}



export function getScanCode(url) {
  return request({
    url: '/api/login/getScanCode',
    method: 'get',
    params: { url }
  })
}

export function wechatCallback(code, state) {
  return request({
    url: '/api/login/wechat/callback',
    method: 'get',
    params: { code, state }
  })
}

// 扫码登录绑定手机号
export function scanBindMobile(data) {
  return request({
    url: '/api/login/scan/bindMobile',
    method: 'post',
    data
  })
}
export function getUserInfo() {
  return request({
    url: '/api/user/info',
    method: 'get',
  })
}

// 获取账号安全信息（密码/绑定/实名认证状态）
export function getUserSecurity() {
  return request({
    url: '/api/user/security',
    method: 'get',
  })
}

// 发送账号手机号验证码
export function sendUserSecurityAccountVerifyCode(data) {
  return request({
    url: '/api/user/security/account-verify/sendCode',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 校验账号手机号验证码并获取 verify_ticket（成功时 data.verify_ticket / expires_in）
export function checkUserSecurityAccountVerifyCode(data) {
  return request({
    url: '/api/user/security/account-verify/check',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 发送邮箱验证码
export function sendUserSecurityEmailCode(data) {
  return request({
    url: '/api/user/security/email/sendCode',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 绑定/修改邮箱
export function bindUserSecurityEmail(data) {
  return request({
    url: '/api/user/security/email/bind',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 发送注销账号邮箱验证码
export function sendUserSecurityCancelEmailCode() {
  return request({
    url: '/api/user/security/cancel/sendCode',
    method: 'post',
    data: {},
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 申请注销账号
export function cancelUserSecurityAccount(data) {
  return request({
    url: '/api/user/security/cancel',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 修改登录密码
export function changeUserSecurityPassword(data) {
  return request({
    url: '/api/user/security/password/change',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 发送新手机号短信验证码（账号安全-绑定/换绑）
export function sendUserSecurityMobileSmsCode(data) {
  return request({
    url: '/api/user/security/mobile/sendSmsCode',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 确认绑定/换绑手机号（账号安全）
export function confirmUserSecurityMobile(data) {
  return request({
    url: '/api/user/security/mobile/confirm',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 解绑邮箱（账号安全）
export function unbindUserSecurityEmail(data) {
  return request({
    url: '/api/user/security/email/unbind',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 微信绑定初始化（账号安全）
export function initUserSecurityWechatBind(data) {
  return request({
    url: '/api/user/security/wechat/bind/init',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 查询微信绑定状态（账号安全）
export function getUserSecurityWechatBindStatus(bindToken) {
  return request({
    url: '/api/user/security/wechat/bind/status',
    method: 'get',
    params: { bindToken }
  })
}


export function userSecurityWechatBindCallback(code, state) {
  const params = {}
  if (code != null && code !== '') params.code = code
  if (state != null && state !== '') params.state = state
  return request({
    url: '/api/user/security/wechat/bind/callback',
    method: 'get',
    params
  })
}

// 解绑微信（账号安全）
export function unbindUserSecurityWechat(data) {
  return request({
    url: '/api/user/security/wechat/unbind',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 初始化实名认证（账号安全）
export function initUserSecurityRealAuth(data) {
  return request({
    url: '/api/user/security/real-auth/init',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 查询实名认证结果（账号安全）
export function getUserSecurityRealAuthResult(certify_id) {
  return request({
    url: '/api/user/security/real-auth/result',
    method: 'get',
    params: { certify_id }
  })
}

// 获取会员信息（订阅状态）
export function getMemberInfo() {
  return request({
    url: '/api/user/member/info',
    method: 'get',
  })
}

// 判断当前用户是否为会员
export function checkIsMember() {
  return request({
    url: '/api/user/member/isMember',
    method: 'get',
  })
}

// 检查是否还有面试次数（会员/免费次数）
export function checkInterview(jobId = null) {
  return request({
    url: '/api/user/member/checkInterview',
    method: 'post',
    data: jobId ? { job_id: jobId } : {}
  })
}

// 开始一次面试（占用一次面试次数）
export function startMemberInterview(jobId = null) {
  return request({
    url: '/api/user/member/startInterview',
    method: 'post',
    data: jobId ? { job_id: jobId } : {}
  })
}
export function sendSmsCode(data) {
  return request({
    url: '/api/sms/sendCode',
    method: 'post',
    data
  })
}
export function updateUser(data) {
  return request({
    url: '/api/user/updateUser',
    method: 'post',
    data
  })
}

export function register(data) {
  return request({
    url: '/api/login/register',
    method: 'post',
    data
  })
}

export function setInfo(data) {
  return request({
    url: '/api/user/setInfo',
    method: 'post',
    data
  })
}
export function loginEmail(data) {
  data.terminal = 4
  return request({
    url: '/api/login/mobileLogin',
    method: 'post',
    data
  })
}

export function login(data) {
  return request({
    url: '/vue-admin-template/user/login',
    method: 'post',
    data
  })
}

export function getInfo(token) {
  return request({
    url: '/api/user/info',
    method: 'get',
    params: { token }
  })
}

export function logout() {
  return request({
    url: '/api/login/logout',
    method: 'post'
  })
}

export function testLogin(data) {
  return request({
    url: '/api/login/mobileLogin',
    method: 'post',
    data
  })
}

export function testbindMnp(data) {
  return request({
    url: '/api/user/bindMnp',
    method: 'post',
    data
  })
}
export function test_bindMobile(data) {
  return request({
    url: '/api/user/bindMobile',
    method: 'post',
    data
  })
}
export function test_bindOa(data) {
  return request({
    url: '/api/user/bindOa',
    method: 'post',
    data
  })
}
export function test_center(data) {
  return request({
    url: '/api/user/center',
    method: 'get',
    data
  })
}
export function changePwd(data) {
  return request({
    url: '/api/user/changePassword',
    method: 'post',
    data
  })
}
export function test_forgotPwd(data) {
  return request({
    url: '/api/user/forgotPwd',
    method: 'post',
    data
  })
}
export function test_getMobileByMnp(data) {
  return request({
    url: '/api/user/getMobileByMnp',
    method: 'post',
    data
  })
}
export function test_uesrinfo(data) {
  return request({
    url: '/api/user/info',
    method: 'get',
    data
  })
}

export function test_resetPassword(data) {
  return request({
    url: '/api/user/resetPassword',
    method: 'post',
    data
  })
}
export function test_setInfo(data) {
  return request({
    url: '/api/user/setInfo',
    method: 'post',
    data
  })
}
export function test_updateUser(data) {
  return request({
    url: '/api/user/updateUser',
    method: 'post',
    data
  })
}

export function loginAccount(data) {
  data.terminal = 4
  return request({
    url: '/api/login/account',
    method: 'post',
    data
  })
}

// 提交用户反馈
export function submitFeedback(data) {
  return request({
    url: '/api/feedback/submit',
    method: 'post',
    data
  })
}

// 获取用户求职期望列表
export function getUserExpectList() {
  return request({
    url: '/api/userExpect/list',
    method: 'get'
  })
}

// 获取用户所有求职期望
export function getUserExpectAll() {
  return request({
    url: '/api/userExpect/user',
    method: 'get'
  })
}


// 添加用户求职期望
export function addUserExpect(data) {
  return request({
    url: '/api/userExpect/add',
    method: 'post',
    data
  })
}

// 删除用户求职期望
export function deleteUserExpect(id) {
  return request({
    url: `/api/userExpect/delete?id=${id}`,
    method: 'delete',
  })
}

// 获取用户期望详情
export function getUserExpectDetail(data) {
  return request({
    url: '/api/userExpect/detail',
    method: 'get',
    params: data
  })
}

// 修改用户期望
export function editUserExpect(data) {
  return request({
    url: '/api/userExpect/edit',
    method: 'post',
    data
  })
}

